module.exports = __webpack_public_path__ + "static/media/2.e1f5369b.png";